import React from "react";

const Speed12StrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1245_187)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 11.841L19.182 8.65902",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 8.659L19.182 11.841",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.94542 14V6.224H1.69742C1.52942 7.04 0.761422 7.664 -0.354578 7.688V8.672H1.52942V14H2.94542ZM4.36395 13.1C4.36395 13.64 4.79595 14.072 5.33595 14.072C5.87595 14.072 6.31995 13.64 6.31995 13.1C6.31995 12.56 5.87595 12.116 5.33595 12.116C4.79595 12.116 4.36395 12.56 4.36395 13.1ZM8.94373 9.14C8.93173 9.008 8.90773 8.864 8.90773 8.744C8.90773 7.94 9.35173 7.304 10.2637 7.304C11.1397 7.304 11.5717 7.88 11.5717 8.516C11.5717 9.08 11.2717 9.548 10.5757 9.98L9.29173 10.784C7.93573 11.624 7.46773 12.668 7.44373 14H13.0717V12.728H9.21973C9.32773 12.344 9.63973 12.068 10.0117 11.84L11.5237 10.904C12.4597 10.328 13.0237 9.5 13.0237 8.492C13.0237 7.16 12.0037 6.044 10.2877 6.044C8.52373 6.044 7.51573 7.256 7.51573 8.6C7.51573 8.756 7.53973 8.936 7.55173 9.044L8.94373 9.14Z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1245_187"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Speed12StrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;